/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_1_TitleInputs */

const en_mk_publish_1_title = /** @type {(inputs: Mk_Publish_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview & check`)
};

const id_mk_publish_1_title = /** @type {(inputs: Mk_Publish_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau & periksa`)
};

/**
* | output |
* | --- |
* | "Preview & check" |
*
* @param {Mk_Publish_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_1_title = /** @type {((inputs?: Mk_Publish_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_1_title(inputs)
	return en_mk_publish_1_title(inputs)
});